import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import customConfirmationLB from "../../../../src/content/london-buses/customConfirmation";
import styles from "../../../../src/content/london-buses/styles";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationLB,
  styles,
  React
};